import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListSubheader from '@mui/material/ListSubheader';


export default function SelectRuota(props) {
   
    const {ruota,setRuota,listaRuote = []} = props
  
    const handleChange = (event) => {

        const val = event.target.value

        if(val > 0) {
            const r = listaRuote.find(el => el.id === val)
            setRuota(r);
        }
        else {
            setRuota(null)
        }

    };
  
    return (
      <FormControl sx={{minWidth: 120, width: 'inherit' }} size="small">
        <InputLabel id="demo-select-small-label"></InputLabel>
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={ruota ? ruota.id : 0}
          label=""
          onChange={handleChange}
        >
        <ListSubheader>MTB</ListSubheader>
        {listaRuote.filter(el => el.bici === 'mtb').map(el => {
            return <MenuItem value={el.id}>{el.tipo}</MenuItem>
        })}
        <ListSubheader>GRAVEL</ListSubheader>
        {listaRuote.filter(el => el.bici === 'gravel').map(el => {
            return <MenuItem value={el.id}>{el.tipo}</MenuItem>
        })}
        <ListSubheader>ALTRO</ListSubheader>
          <MenuItem value={0}>
            <em>Personalizzata</em>
          </MenuItem>
          
        </Select>
      </FormControl>
    );
  }